/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IExample } from '../../core/models/common/IExample';
import { Oas30Example } from '../../openapi/v3/models/Oas30Example';
import { Oas30Parameter } from '../../openapi/v3/models/Oas30Parameter';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete a single example.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteParameterExampleCommand_30 extends AbstractCommand {
    public _exampleName : string;

    public _parameterPath : NodePath;

    public _oldExample : any;

    public constructor(example? : any) {
        if(((example != null && example instanceof <any>Oas30Example) || example === null)) {
            let __args = arguments;
            super();
            if(this._exampleName===undefined) this._exampleName = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExample===undefined) this._oldExample = null;
            if(this._exampleName===undefined) this._exampleName = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExample===undefined) this._oldExample = null;
            (() => {
                this._exampleName = example.getName();
                this._parameterPath = Library.createNodePath(example.parent());
            })();
        } else if(example === undefined) {
            let __args = arguments;
            super();
            if(this._exampleName===undefined) this._exampleName = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExample===undefined) this._oldExample = null;
            if(this._exampleName===undefined) this._exampleName = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._oldExample===undefined) this._oldExample = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteExampleCommand] Executing.");
        this._oldExample = null;
        let parameter : Oas30Parameter = <Oas30Parameter>this._parameterPath.resolve(document);
        if(this.isNullOrUndefined(parameter) || this.isNullOrUndefined(parameter.getExample$java_lang_String(this._exampleName))) {
            LoggerCompat.debug("[DeleteExampleCommand] No example named: " + this._exampleName);
            return;
        }
        let example : IExample = parameter.removeExample(this._exampleName);
        this._oldExample = Library.writeNode(<Node><any>example);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteExampleCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldExample)) {
            return;
        }
        let parameter : Oas30Parameter = <Oas30Parameter>this._parameterPath.resolve(document);
        if(this.isNullOrUndefined(parameter)) {
            LoggerCompat.info("[DeleteExampleCommand] No parameter found.");
            return;
        }
        let example : Oas30Example = parameter.createExample(this._exampleName);
        Library.readNode(this._oldExample, example);
        parameter.addExample(example);
    }
}
DeleteParameterExampleCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteParameterExampleCommand_30";
DeleteParameterExampleCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




